import { motion } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: center;
    align-items: start;

    padding-top: 6rem;

    @media (max-width: 768px) {
        padding-top: 0;
    }

    backdrop-filter: blur(2px);
`;

export const ModalWrapper = styled.div`
    max-width: 80rem;
    width: 50vw;

    overflow-y: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10001;
    border-radius: 1.25rem;
    padding: 1rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
        font-weight: 600;
        padding-bottom: 1rem;
        font-size: 1.25rem;
    }

    @media (max-width: 768px) {
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
    }
`;

export const ModalTitleClose = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;

    p {
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.5rem;
        color: ${({ theme }) => theme.colors['neutral-900']};
    }
`;

export const ModalContent = styled.div`
    color: ${({ theme }) => theme.colors['neutral-900']};
    padding-top: .75rem;

    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
    gap: 1.5rem;
    width: 100%;
    overflow: hidden;

    p {
        margin-bottom: 1rem;
        line-height: 1.5rem;
    }
`;

export const CloseModalButton = styled(LuX)`
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
    padding: 0;
    z-index: 10;
    z-index: 10001;
`;

export const ModalTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: flex-start;

    .icon {
        width: 32px;
        height: 32px;
    }

    p {
        padding: 0;
    }
`;